<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        新增文物档案
      </div>
    </div>
    <ul class="tab-wrap">
      <li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index)" v-for="(tab, index) in tabList" :key="index">
        {{ tab.title }}
      </li>
      <!-- <li
        :class="`tab-btn ${nowIndex == tabList.length && 'active'}`"
        @click="changeTab(tabList.length)"
        v-if="$route.query.id"
      >
        隐患信息
      </li> -->
    </ul>

    <!-- 基本信息 -->

    <el-form ref="form" :model="form" label-width="110px" :rules="rules" class="mt20" v-show="nowIndex == 0">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="建筑名称"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="wenwuBasicInformation.buildName"
          >
            <el-input v-model="form.wenwuBasicInformation.buildName"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="建筑编号" prop="wenwuBasicInformation.buildNum">
            <el-input v-model="form.wenwuBasicInformation.buildNum"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" style="">
          <el-form-item
            label="管理单位"
            prop="wenwuBasicInformation.managementUnit"
            class=""
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <div class="flex">
              <el-select v-if="form.wenwuBasicInformation.remark == 1" filterable v-model="form.wenwuBasicInformation.managementUnit">
                <el-option v-for="(item, index) in companyList" :key="index" :value="item.c_company_num" :label="item.c_name"></el-option>
              </el-select>
              <el-input v-model="form.wenwuBasicInformation.managementUnit" style="width: 10%" v-if="form.wenwuBasicInformation.remark == 0"></el-input>
              <el-button @click="changeClick">自定义</el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="权属"
            prop="wenwuBasicInformation.tenure"
            style="width: 100%"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <el-select v-model="form.wenwuBasicInformation.tenure">
              <el-option value="1" label="国有"></el-option>
              <el-option value="2" label="共有"></el-option>
              <el-option value="3" label="个人"></el-option>
            </el-select>
            <!-- <el-input v-model="form.wenwuBasicInformation.tenure"></el-input> -->
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="使用现状" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="wenwuBasicInformation.useStatus">
            <el-input v-model="form.wenwuBasicInformation.useStatus"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="地区" prop="wenwuBasicInformation.area" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-cascader
              :options="area"
              v-model="areaValue"
              @change="areaChange"
              :props="{
                value: 'areaCode',
                label: 'areaName',
                children: 'child',
              }"
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.areaName }}</span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="详细地址"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="wenwuBasicInformation.address"
          >
            <el-input v-model="form.wenwuBasicInformation.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            label="始建年代"
            prop="wenwuBasicInformation.constructionTime"
          >
            <el-input v-model="form.wenwuBasicInformation.constructionTime"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="墙面做法" prop="wenwuBasicInformation.wallStructure">
            <!-- <v-select :value.sync="form.wenwuBasicInformation.wallStructure" :id="38"></v-select> -->
            <el-input v-model="form.wenwuBasicInformation.wallStructure"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="墙地面做法" prop="wenwuBasicInformation.wallFloorStructure">
            <el-input v-model="form.wenwuBasicInformation.wallFloorStructure"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="楼梯做法" prop="wenwuBasicInformation.stairsStructure">
            <el-input v-model="form.wenwuBasicInformation.stairsStructure"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="台阶做法" prop="wenwuBasicInformation.stepsStructure">
            <el-input v-model="form.wenwuBasicInformation.stepsStructure"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="基础做法" prop="wenwuBasicInformation.baseStructure">
            <el-input v-model="form.wenwuBasicInformation.baseStructure"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="6">
          <el-form-item label="安装信息表" prop="wenwuBasicInformation.c_setup_table">
            <el-radio-group v-model="form.wenwuBasicInformation.c_setup_table">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="省" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="wenwuBasicInformation.c_province">-->
        <!--                        <el-select v-model="form.wenwuBasicInformation.c_province" placeholder="请选择省份" @change="proChanege">-->
        <!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
        <!--                                       v-for="item in allAreaList"></el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="市" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="wenwuBasicInformation.c_city">-->
        <!--                        <el-select v-model="form.wenwuBasicInformation.c_city" placeholder="请选择市" @change="cityChanege">-->
        <!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
        <!--                                       v-for="item in cityList"></el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="区" :rules="{message:'请填写/选择',trigger:'change',required:true}" prop="wenwuBasicInformation.c_area">-->
        <!--                        <el-select v-model="form.wenwuBasicInformation.c_area" placeholder="请选择区">-->
        <!--                            <el-option :value="item.area_code+''" :label="item.area_name"-->
        <!--                                       v-for="item in areaList"></el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->

        <!-- <el-col :span="6">
          <el-form-item
            label-width="140px"
            label="消防安全重点单位"
            prop="wenwuBasicInformation.c_import_company"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-radio-group v-model="form.wenwuBasicInformation.c_import_company">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->

        <el-col :span="6">
          <el-form-item label="屋面做法" prop="wenwuBasicInformation.roofStructure">
            <el-input v-model="form.wenwuBasicInformation.roofStructure"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="门" prop="wenwuBasicInformation.door">
            <el-input v-model="form.wenwuBasicInformation.door"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="窗" prop="wenwuBasicInformation.windows">
            <el-input v-model="form.wenwuBasicInformation.windows"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备设施" prop="wenwuBasicInformation.equipmentFacilities">
            <el-input v-model="form.wenwuBasicInformation.equipmentFacilities"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="梁架结构" prop="wenwuBasicInformation.beamStructure">
            <el-input v-model="form.wenwuBasicInformation.beamStructure"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="140px" label="名木古树" prop="wenwuBasicInformation.famousOldtree">
            <el-input v-model="form.wenwuBasicInformation.famousOldtree"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="管理现状" prop="wenwuBasicInformation.managementStatus">
            <el-input v-model="form.wenwuBasicInformation.managementStatus"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="总体面积(m²)" prop="wenwuBasicInformation.overallAreaStr">
            <el-input @keyup.native="checkNum" v-model="form.wenwuBasicInformation.overallAreaStr"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="建筑联系人" prop="wenwuBasicInformation.buildContact">
            <el-input v-model="form.wenwuBasicInformation.buildContact"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="联系电话" prop="wenwuBasicInformation.phone">
            <el-input v-model="form.wenwuBasicInformation.phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 主要建筑材料 -->

      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">主要建筑材料</div>
      </div>
      <div class="btn-box">
        <div
          class="btn ml10"
          v-if="!$route.query.view"
          @click="
            form.wenwuBuildMaterialsList.unshift({
              name: '',
              material: '',
              basicData: '',
            })
          "
        >
          <i class="icon-tr-newly-added"></i>添加
        </div>
      </div>
      <el-row>
        <el-form-item v-model="form.wenwuBuildMaterialsList" prop="wenwuBasicInformation.c_land_area">
          <table class="common-table mt20">
            <thead>
              <tr>
                <th>名称</th>
                <th>材料</th>

                <th>基本数据</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in form.wenwuBuildMaterialsList" :key="index">
                <td>
                  <el-input v-model="item.name"></el-input>
                </td>
                <td>
                  <el-input v-model="item.material"></el-input>
                </td>
                <td>
                  <el-input v-model="item.basicData"></el-input>
                </td>
                <td>
                  <a v-if="!$route.query.view" class="clear-data" @click="form.wenwuBuildMaterialsList.splice(index, 1)">
                    <i class="icon-tr-delete"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <el-row v-for="(item,index) in form.build">
              
              <el-col :span="6">
            <el-input v-model="item.c_total_area"></el-input>

                  </el-col>  
              <el-col :span="6">

            <el-input v-model="item.c_total_area"></el-input>
              </el-col>
              <el-col :span="6">

            <el-input v-model="item.c_total_area"></el-input>
              </el-col>
          </el-row> -->
        </el-form-item>
      </el-row>

      <el-row>
        <div class="tab-hr">
          <span></span>
          <div class="flex1 ml10">介绍资料</div>
        </div>
        <el-row class="mt10">
          <el-col :span="24">
            <el-form-item
              label="建筑简介及特色"
              prop="wenwuBasicInformation.buildIntroduction"
              :rules="{
                message: '请填写/选择',
                trigger: 'change',
                required: true,
              }"
            >
              <el-input type="textarea" v-model="form.wenwuBasicInformation.buildIntroduction"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mt10">
          <el-col :span="24">
            <el-form-item label="建筑历史及使用沿革" prop="wenwuBasicInformation.buildHistory">
              <el-input type="textarea" v-model="form.wenwuBasicInformation.buildHistory"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mt10">
          <el-col :span="24">
            <el-form-item label="现存主要问题" prop="wenwuBasicInformation.existProblems">
              <el-input type="textarea" v-model="form.wenwuBasicInformation.existProblems"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">其他附件</div>
      </div>
      <div class="btn-box">
        <div
          class="btn ml10"
          v-if="!$route.query.view"
          @click="
            addFile('wenwuAttachmentList', {
              attachmentNum: '',
              attachmentRemark: '',
              attachmentType: '',
              attachmentUrl: '',
              fileList: {},
              files: [],
              fileRules: {
                size: 10000000,
                type: ['pdf', 'doc', 'docx', 'html', 'txt', 'jpg', 'png', 'jpeg'],
              },
            })
          "
        >
          <i class="icon-tr-newly-added"></i>添加
        </div>
      </div>
      <el-form-item prop="wenwuBasicInformation.c_land_area">
        <div
          v-for="(it, index) in form.wenwuAttachmentList"
          :key="index"
          style="
            border: 1px solid #eee;
            padding-bottom: 20px;
            position: relative;
          "
          class="mt20"
        >
          <div style="float: right; position: absolute; right: 10px; z-index: 9999" @click="fileDel('wenwuAttachmentList', index)">
            <a v-if="!$route.query.view" class="clear-data">
              <i class="icon-tr-delete"></i>
            </a>
          </div>
          <el-row>
            <el-col class="ml20" :span="6">
              <span>附件类型</span>
              <el-input type="text" v-model="it.attachmentType"></el-input>
            </el-col>
            <el-col class="ml20" :span="6">
              <span>附件编号</span>
              <el-input type="text" v-model="it.attachmentNum"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="ml20" :span="12">
              <span>附件备注</span>
              <el-input type="textarea" v-model="it.attachmentRemark"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="ml20">
              <span>附件名</span>
              <el-upload
                class="upload-demo"
                drag
                action="."
                
                :on-preview="
                  (file) => {
                    return preview(file, 'wenwuAttachmentList', 'attachmentUrl', index);
                  }
                "
                :disabled="fileChecking || $route.query.view"
                :before-upload="
                  (file) => {
                    return beforeUpload(file, it.fileRules);
                  }
                "
                :http-request="
                  (file) => {
                    return upload(file, 'wenwuAttachmentList', 'attachmentUrl', index);
                  }
                "
                :on-remove="
                  (file) => {
                    return beforeRemove(file, 'wenwuAttachmentList', 'attachmentUrl', index);
                  }
                "
                multiple
                list-type="text"
              
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>,<span class="rulesColor">支持pdf, doc, docx, html, txt, jpg, png等格式文件上传，文件大小不超过10MB</span>
                </div>
              </el-upload>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
    </el-form>
    <!-- 图片信息 -->
    <el-form ref="form1" :model="form" label-width="150px" :rules="rules" class="mt20" v-show="nowIndex == 1">
      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">文物建筑标志信息</div>
      </div>

      <el-row>
        <el-col :span="9" class="ml20">
          <el-form-item prop="form.wenwuBasicInformation.buildSignInformation">
            <el-upload
              class="avatar-uploader"
              action="."
              list-type="picture-card"
              @click="alert(1)"
              :disabled="fileChecking || $route.query.view"
              :before-upload="
                (file) => {
                  return beforeUpload(file, {
                    size: 10000000,
                    type: ['png', 'jpg', 'jpeg'],
                  });
                }
              "
              :http-request="
                (file) => {
                  return upload(file, 'buildSignInformation');
                }
              "
              :on-remove="
                (file) => {
                  return beforeRemove(file, 'buildSignInformation');
                }
              "
              :limit="1"
              :file-list="SignFileList"
            >
              <!-- <i  class="el-icon-plus "></i> -->
              <span class="rulesColor">
                支持jpg, png,jpeg等格式文件上传，文件大小不超过10MB(限1张)
              </span>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">建筑图片</div>
      </div>
      <div class="btn-box">
        <div
          class="btn ml10"
          v-if="!$route.query.view"
          @click="
            addFile('wenwuImageInformationsList', {
              attachmentName: '',
              attachmentNum: '',
              attachmentRemark: '',
              attachmentUrl: '',
              remark: '',
              filmingPeople: '',
              filmingTime: '',
              fileList: {},
              files: [],
              fileRules: { size: 10000000, type: ['png', 'jpg', 'jpeg'] },
            })
          "
        >
          <i class="icon-tr-newly-added"></i>添加
        </div>
      </div>
      <el-row>
        <el-form-item prop="wenwuBasicInformation.c_land_area" label-width="110px">
          <div
            v-for="(it, index) in form.wenwuImageInformationsList"
            :key="index"
            style="
              border: 1px solid #eee;
              padding-bottom: 20px;
              position: relative;
            "
            class="mt20"
          >
            <div
              style="
                float: right;
                position: absolute;
                right: 10px;
                z-index: 9999;
              "
              @click="fileDel('wenwuImageInformationsList', index)"
            >
              <a v-if="!$route.query.view" class="clear-data">
                <i class="icon-tr-delete"></i>
              </a>
            </div>
            <el-row>
              <el-col class="ml20" :span="6">
                <span>附件名称</span>
                <el-input type="text" v-model="it.attachmentName"></el-input>
              </el-col>
              <el-col class="ml20" :span="6">
                <span>附件编号</span>
                <el-input type="text" v-model="it.attachmentNum"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="ml20" :span="12">
                <span>附件备注</span>
                <el-input type="textarea" v-model="it.attachmentRemark"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="ml20" :span="12">
                <span>拍摄人</span>
                <el-input type="textarea" v-model="it.filmingPeople"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="ml20" :span="12">
                <span>拍摄时间</span>
                <!-- <el-input type="textarea" v-model="it.filmingTime"></el-input> -->
                <el-date-picker v-model="it.filmingTime" type="datetime" placeholder="拍摄时间" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="ml20" :span="12">
                <span>照片描述</span>
                <el-input type="textarea" v-model="it.remark"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="ml20">
                <span>附件</span>
                <el-upload
                  class="upload-demo"
                  action="."
                  :file-list="it.files"
                  :on-preview="
                    (file) => {
                      return preview(file, 'wenwuImageInformationsList', 'attachmentUrl', index);
                    }
                  "
                  :on-remove="
                    (file) => {
                      return beforeRemove(file, 'wenwuImageInformationsList', 'attachmentUrl', index);
                    }
                  "
                  :disabled="fileChecking || $route.query.view"
                  :before-upload="
                    (file) => {
                      return beforeUpload(file, it.fileRules);
                    }
                  "
                  :http-request="
                    (file) => {
                      return upload(file, 'wenwuImageInformationsList', 'attachmentUrl', index);
                    }
                  "
                  multiple
                  list-type="picture-card"
                  :limit="1"
                >
                  <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                  <span class="rulesColor">
                    支持jpg, png,jpeg等格式文件上传，文件大小不超过10MB(限1张)
                  </span>
                </el-upload>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 建筑信息 -->
    <el-form ref="form2" :model="form" label-width="150px" :rules="rules" class="mt20" v-show="nowIndex == 2">
      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">文物建筑范围信息</div>
      </div>

      <el-row>
        <el-col :span="9" class="ml20">
          <el-form-item prop="form.wenwuBasicInformation.buildScopeInformation">
            <el-upload
              class="avatar-uploader"
              action="."
              :file-list="ScopeIFileList"
              :on-remove="
                (file) => {
                  return beforeRemove(file, 'buildScopeInformation');
                }
              "
              :before-upload="
                (file) => {
                  return beforeUpload(file, {
                    size: 10000000,
                    type: ['png', 'jpg', 'jpeg'],
                  });
                }
              "
              @click="alert(1)"
              :disabled="fileChecking || $route.query.view"
              :http-request="
                (file) => {
                  return upload(file, 'buildScopeInformation');
                }
              "
              :limit="1"
              list-type="picture-card"
            >
              <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
              <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
              <span class="rulesColor">
                支持jpg, png,jpeg等格式文件上传，文件大小不超过10MB(限1张)
              </span>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">现状测绘图</div>
      </div>
      <div class="btn-box">
        <!-- <div
          class="btn ml10"
      v-if="!$route.query.view"
          
          v-hasPermi="['basic:company:add']"
          @click="form.wenwuImageInformationsList.unshift({ attachmentName: '', attachmentNum: '', attachmentRemark: '',attachmentUrl:'',filmingPeople:'', filmingTime:''})"
        >
          <i class="icon-tr-newly-added"></i>添加
        </div> -->
      </div>
      <el-row>
        <el-form-item prop="wenwuBasicInformation.c_land_area" label-width="110px">
          <div style="padding-bottom: 20px; position: relative" class="mt20">
            <el-row>
              <el-col :span="8" class="ml20">
                <span>上传图纸</span>
                <el-upload
                  class="upload-demo"
                  action="."
                  @click="alert(1)"
                  :disabled="fileChecking || $route.query.view"
                  :before-upload="
                    (file) => {
                      return beforeUpload(file, {
                        size: 10000000,
                        type: ['png', 'jpg', 'jpeg'],
                      });
                    }
                  "
                  :http-request="
                    (file) => {
                      return upload(file, 'mappingUrl');
                    }
                  "
                  :file-list="mappingList"
                  :on-remove="
                    (file) => {
                      return beforeRemove(file, 'mappingUrl');
                    }
                  "
                  multiple
                  list-type="picture-card"
                  :limit="10"
                >
                  <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
                  <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                  <span class="rulesColor">
                    支持jpg, png,jpeg等格式文件上传，文件大小不超过10MB
                  </span>
                </el-upload>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 修缮记录 -->
    <el-form ref="form3" :model="form" label-width="150px" :rules="rules" class="mt20" v-show="nowIndex == 3">
      <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">建筑图片</div>
      </div>
      <div class="btn-box">
        <div
          class="btn ml10"
          v-if="!$route.query.view"
          @click="
            addFile('wenwuRepairRecordsList', {
              phone: '',
              repairAfterImage: '',
              repairBeforeImage: '',
              repairPart: '',
              repairProblems: '',
              repairTime: '',
              remark: '',
              repairPrincipal: '',
              fileList: {},
              files: [],
              beforeFiles: [],
              afterFiles: [],
            })
          "
        >
          <i class="icon-tr-newly-added"></i>添加
        </div>
      </div>
      <div
        v-for="(it, index) in form.wenwuRepairRecordsList"
        :key="index"
        style="
          border: 1px solid #eee;
          padding: 20px 0;
          position: relative;
          margin-left: 110px;
        "
        class="mt20"
      >
        <div style="float: right; position: absolute; right: 10px; z-index: 9999" @click="form.wenwuRepairRecordsList.splice(index, 1)">
          <a v-if="!$route.query.view" class="clear-data">
            <i class="icon-tr-delete"></i>
          </a>
        </div>
        <el-row>
          <el-col :span="6">
            <el-form-item label="修缮问题" prop="wenwuRepairRecordsList.repairProblems">
              <el-input v-model="it.repairProblems"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="修缮部位" prop="wenwuRepairRecordsList.repairPart">
              <el-input v-model="it.repairPart"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="修缮负责人" prop="wenwuRepairRecordsList.repairPrincipal">
              <el-input v-model="it.repairPrincipal"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item
              label="修缮时间

"
              prop="wenwuRepairRecordsList.phone"
            >
              <el-date-picker v-model="it.repairTime" type="datetime" placeholder="拍摄时间" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="联系电话

"
              prop="wenwuRepairRecordsList.phone"
            >
              <el-input v-model="it.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="备注

"
              prop="wenwuRepairRecordsList.phone"
            >
              <el-input v-model="it.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="ml20">
            <!-- <span>附件名</span> -->
            <!-- <el-form-item> -->
            <el-form-item label="修缮前图片" prop="wenwuRepairRecordsList.phone">
              <el-upload
                class="upload-demo"
                action="."
                :on-remove="
                  (file) => {
                    return beforeXiuRemove(file, 'repairBeforeImage', index);
                  }
                "
                @click="alert(1)"
                :disabled="fileChecking || $route.query.view"
                :before-upload="
                  (file) => {
                    return beforeUpload(file, {
                      size: 10000000,
                      type: ['png', 'jpg', 'jpeg'],
                    });
                  }
                "
                :http-request="
                  (file) => {
                    return upload(file, 'wenwuRepairRecordsList', 'repairBeforeImage', index);
                  }
                "
                list-type="picture-card"
                :file-list="it.beforeFiles"
                :limit="3"
              >
                <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                <span class="rulesColor">
                  支持jpg, png,jpeg等格式文件上传，文件大小不超过10MB，可上传多张
                </span>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" class="ml20">
            <!-- <span>附件名</span> -->
            <!-- <el-form-item> -->
            <el-form-item label="修缮后图片" prop="wenwuRepairRecordsList.phone">
              <el-upload
                class="upload-demo"
                action="."
                :file-list="it.afterFiles"
                @click="alert(1)"
                :disabled="fileChecking || $route.query.view"
                :before-upload="
                  (file) => {
                    return beforeUpload(file, {
                      size: 10000000,
                      type: ['png', 'jpg', 'jpeg'],
                    });
                  }
                "
                :http-request="
                  (file) => {
                    return upload(file, 'wenwuRepairRecordsList', 'repairAfterImage', index);
                  }
                "
                :on-remove="
                  (file) => {
                    return beforeXiuRemove(file, 'repairAfterImage', index);
                  }
                "
                list-type="picture-card"
                :limit="3"
              >
                <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                <span class="rulesColor">
                  支持jpg, png,jpeg等格式文件上传，文件大小不超过10MB，可上传多张
                </span>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <!--四有档案  -->
    <div v-if="nowIndex == 4" style="height: 750px; width: 100%">
      <iframe width="100%" height="100%" :src="siyouUrl" frameborder="0" class="flex1"></iframe>
    </div>
    <div class="center">
      <el-button class="l-btn" type="primary" :loading="isUpload" @click="onSubmit" v-if="!$route.query.view">
        保存
      </el-button>
      <el-button class="l-btn ml20" type="primary" @click="$router.back(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
import { addCompany, editCompany } from "../../../api/company";
import { getAreaNew } from "../../../api/common";
import OSS from "ali-oss";
import { stringify } from "querystring";
// import { sigtype, port } from "../options";
// import {buildList} from './build-list'

// import getLoation from "./getLoation";
// import danger from "./danger";
// import reportcompany from "@/components/reportcomp"

export default {
  data() {
    return {
      services: [],
      isUpload: false,
      fileChecking: false,
      siyouUrl: "", // 四有档案
      shuiLoading: false,
      basicfileList: [[]], // 建筑附件上传
      fileType: "", // 上传类型 添加的数组
      fileList: {}, // 单个上传
      failUploading: {},
      companyList: [], // 管理单位
      area: [],
      areaValue: ["370000", "370200", "370202"],
      // shangjioption: [],
      // checkList: [], //维保选项
      // yuanqvoption: [],
      SignFileList: [], // 标志图片
      ScopeIFileList: [], // 范围图片
      mappingList: [],
      form: {
        wenwuBasicInformation: {
          address: "",
          remark: "1",
          baseStructure: "",
          beamStructure: "",
          buildContact: "",
          buildHistory: "",
          buildIntroduction: "",
          buildName: "",
          buildNum: "",
          buildScopeInformation: "",
          buildSignInformation: "",
          companyNum: "",
          constructionTime: "",
          door: "",
          equipmentFacilities: "",
          existProblems: "",
          famousOldtree: "",
          managementStatus: "",
          managementUnit: "",
          overallAreaStr: "", // 总体面积
          phone: "",
          mappingUrl: "",
          province: 0, // 省编号
          city: 0, //市编号
          area: 0, // 区编号
          roofStructure: "",
          stairsStructure: "",
          stepsStructure: "",
          tenure: "",
          useStatus: "",
          wallFloorStructure: "",
          wallStructure: "",
          windows: "",
        },
        wenwuBuildMaterialsList: [{ name: "", material: "", basicData: "" }], // 基本信息 材料
        wenwuAttachmentList: [
          // 基本信息 附件
          {
            attachmentNum: "",
            attachmentRemark: "",
            attachmentType: "",
            attachmentUrl: "",
            fileList: {},
            files: [],
            fileRules: {
              size: 10000000,
              type: ["pdf", "doc", "docx", "html", "txt", "jpg", "png", "jpeg"],
            },
          },
        ],
        wenwuImageInformationsList: [
          {
            //基本信息对象的id,新增不用传,修改需要传
            attachmentName: "",
            attachmentNum: "",
            attachmentRemark: "",
            attachmentUrl: "",
            remark: "",
            filmingPeople: "",
            filmingTime: "", //拍摄时间
            fileList: {},
            files: [],
            fileRules: { size: 10000000, type: ["png", "jpg", "jpeg"] },
          },
        ],
        wenwuRepairRecordsList: [
          {
            phone: "",
            repairAfterImage: "",
            repairBeforeImage: "",
            repairPart: "",
            repairProblems: "",
            repairTime: "",
            remark: "",
            repairPrincipal: "",
            fileList: {},
            files: [],
            beforeFiles: [],
            afterFiles: [],
          },
        ],
        // 建筑图片
      },
      rules: {},
      nowIndex: 0,
      allAreaList: [],
      cityList: [],
      areaList: [],
      tabList: [
        {
          title: "基本信息",
          form: "wenwuBasicInformation",
        },
        { title: "图片信息", form: "" },

        {
          title: "建筑信息",
        },
        {
          title: "修缮记录",
          form: "get_emphasis",
        },

        // {
        //   title: "消控室",
        //   form: "get_control",
        //   data: [
        //     { form_name: "cc_num", type: "text", text: "消控室编号" },
        //     { form_name: "cc_name", type: "text", text: "消控室名称" },
        //     { form_name: "cc_build", type: "text", text: "所属建筑" },
        //     { form_name: "cc_address", type: "text", text: "地址" },
        //     { form_name: "cc_user", type: "text", text: "责任人" },
        //     { form_name: "cc_device", type: "text", text: "设备" },
        //   ],
        // },

        // {
        //   title: "巡查区域",
        //   form: "get_area",
        //   data: [
        //     { form_name: "x_company_area", type: "text", text: "区域" },
        //   ],
        // },     {
        //   title: "巡查时间",
        //   form: "get_rate",
        //   data: [
        //     { form_name: "start_time", type: "timmer", text: "时间" },
        //     { form_name: "z_status", type: "select", text: "是否启用",  option: [
        //         { mc_id: 1, mc_name: "是" },
        //         { mc_id: 0, mc_name: "否" },

        //       ] },

        //   ],
        // },
      ],
    };
  },
  created() {
    this.$post("/devicemanage/selectconpanybyme").then((res) => {
      this.companyList = res.data;
    });

    getAreaNew().then((res) => {
      this.area = res.data;
      // this.area.forEach((a) => {
      //   a.childArea.forEach((b) => {
      //     //log(b.childArea)
      //     b.childArea.forEach((c) => {
      //       if (!c.childArea.length) {
      //         c.childArea = null;
      //       }
      //     });
      //   });
      // });
    });
    this.$post("/trxf/main/xf/danwei/xfdanweixinxi/querybasemap").then((res) => {
      var arr = [];
      var arr1 = [];
      res.data[0].map((item, index) => {
        arr.push({ key: item.c_name, value: item.company_num });
      });
      res.data[1].map((item, index) => {
        arr1.push({ key: item.c_name, value: item.company_num });
      });
      arr.unshift({ key: "无", value: "0" });
      arr1.unshift({ key: "无", value: "0" });

      this.shangjioption = arr;
      this.yuanqvoption = arr1;
    });

    if (this.$route.query.id) {
      if (this.$route.query.view) {
        this.tabList.push({
          title: "四有档案",
        });
      }
      setTimeout(() => {
        this.getList();
      }, 10);
    }
  },
  mounted() {},
  components: {},
  computed: {
    isUpload() {
      for (let i in this.fileList) {
        if (this.fileList[i].uploading) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    checkNum() {
      this.form.wenwuBasicInformation.overallAreaStr = this.proving(this.form.wenwuBasicInformation.overallAreaStr);
    },
    proving(str) {
      str = str.replace(/[^\d.]/g, "");
      // 必须保证第一个为数字而不是.
      str = str.replace(/^\./g, "");
      // 保证只有出现一个.而没有多个.
      str = str.replace(/\.{2,}/g, "");
      // 保证.只出现一次，而不能出现两次以上
      str = str
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      let index = -1;
      for (let i in str) {
        if (str[i] === ".") {
          index = i;
        }
        if (index !== -1) {
          if (i - index > 1) {
            str = str.substring(0, str.length - 1);
          }
        }
      }
      return str;
    },
    changeClick() {
      this.form.wenwuBasicInformation.remark == 1 ? (this.form.wenwuBasicInformation.remark = "0") : (this.form.wenwuBasicInformation.remark = "1");
    },
    beforeUpload(file, rules) {
      var tp = file.name.split(".")[1];
      // console.log()
      // return false
      if (rules) {
        if (rules.type.indexOf(tp) == -1) {
          this.$message.warning("不支持的上传类型");
          return false;
        } else if (file.size > rules.size) {
          this.$message.warning("文件内容过大");
          return false;
        }
      } else {
        this.$message.error("文件读取错误");
        return false;
      }
    },
    preview(val, type, pathKey, index) {
      if (index || index == 0) {
        var filesList = this.form[type][index].files;
        // 删除当前文件本地

        for (var i in filesList) {
          if (filesList[i].uid === val.uid) {
            window.location.href = filesList[i].url;
          }
        }
      }
    },
    addFile(formName, formContent) {
      this.form[formName].unshift(formContent);
      // if(fileupName){
      //   this[fileupName].unshift(upLoadContent ||[])
      // }
    },
    fileDel(formName, index, fileupName) {
      this.form[formName].splice(index, 1);
      if (fileupName) {
        this[fileupName].splice(index, 1);
      }
    },

    beforeRemove(val, type, pathKey, index) {
      //  if(type=='wenwuRepairRecordsList' &&pathKey){
      //   alert(1)
      //   console.log(val)
      //   console.log(this.form[type][index][pathKey])
      //   return
      // }
      if (index || index == 0) {
        var filesList = this.form[type][index].fileList;
        var path = this.form[type][index][pathKey];
        var newArr = path.split(",");
        newArr.map((item, ind) => {
          if (item === val.key) {
            newArr.splice(ind, 1);
          }
        });
        this.form[type][index][pathKey] = newArr.join(",").charAt(0) == "," ? newArr.join(",").substr(1) : newArr.join(",");
        console.log(this.form[type][index][pathKey]);
        // 删除当前文件本地
        for (var i in filesList) {
          if (filesList[i].uid === val.uid) {
            delete filesList[i];
          }
        }
      } else {
        // 多个删除
        // alert(33)

        var str = this.form.wenwuBasicInformation[type];
        if (type == "mappingUrl") {
          // var str = this.form.wenwuBasicInformation[type];
          // var newArr = str.split(",");
          // newArr.map((item, ind) => {
          //   if (item === val.key) {
          //     alert(67788);
          //     newArr.splice(ind, 1);
          //   }
          //   console.log(newArr);
          //   this.form.wenwuBasicInformation[type] =
          //     newArr.join(",").charAt(0) == ","
          //       ? newArr.join(",").substr(1)
          //       : newArr.join(",");

          //   console.log(this.form.wenwuBasicInformation[type]);
          // });
          this.mappingList.map((item, index) => {
            if (val.uid) {
              if (item.uid === val.uid) {
                this.mappingList.splice(index, 1);
              }
            }
          });
        } else {
          this.form.wenwuBasicInformation[type] = "";
        }

        for (var i in this.fileList) {
          if (this.fileList[i].uid === val.uid) {
            delete this.fileList[i];
          }
        }
      }
    },
    // 处理 修缮删除

    beforeXiuRemove(val, type, index) {
      if (type == "repairAfterImage") {
        this.form.wenwuRepairRecordsList[index].afterFiles.map((item, index) => {
          if (item.key === val.key || item.uid === val.uid) {
            this.form.wenwuRepairRecordsList[index].afterFiles.splice(index, 1);
          }
        });
      } else {
        this.form.wenwuRepairRecordsList[index].beforeFiles.map((item, index) => {
          if (item.key === val.key || item.uid === val.uid) {
            this.form.wenwuRepairRecordsList[index].beforeFiles.splice(index, 1);
          }
        });
      }

      var str = this.form.wenwuRepairRecordsList[index][type];
      var newArr = str.split(",");
      newArr.map((item, ind) => {
        if (item === val.key) {
          newArr.splice(ind, 1);
        }
        this.form.wenwuRepairRecordsList[index][type] = newArr.join(",").charAt(0) == "," ? newArr.join(",").substr(1) : newArr.join(",");
      });
      for (var i in this.form.wenwuRepairRecordsList[index].fileList) {
        if (this.form.wenwuRepairRecordsList[index].fileList[i].uid === val.uid && this.form.wenwuRepairRecordsList[index].fileList[i].pathKey == type) {
          delete this.form.wenwuRepairRecordsList[index].fileList[i];
        }
      }
      // for(var i in this.form.wenwuRepairRecordsList[index].fileList){
      //   console.log(i)
      //   if(this.form.wenwuRepairRecordsList[index].fileList[i].uuid===files.uuid){
      //     alert(4123)
      //     delete this.form.wenwuRepairRecordsList[index].fileList[i]
      //   }
      // }
    },
    upload(val, type, pathKey, index) {
      let client = new OSS(this.$bus.config.ossConfig);
      let file = val.file;
      let _this = this;
      let id = this.$bus.config.dangan + "/t" + Date.now() + "s" + file.size + "/" + file.name;

      var fileList = null;

      if (index || index == 0) {
        this.$set(this.form[type][index].fileList, id, {
          name: file.name,
          size: file.size,
          uid: file.uid,
          uploading: true,
          time: 0,
          progress: 0,
          key: id,
          client: client,
          type: type,
          pathKey,
          typeIndex: index,
        });
        fileList = this.form[type][index].fileList;
      } else {
        this.$set(this.fileList, id, {
          name: file.name,
          size: file.size,
          uploading: true,
          uid: file.uid,

          time: 0,
          progress: 0,
          key: id,
          client: client,
          type: type,
          pathKey,
        });
        fileList = this.fileList;
      }
      // _this.getTimes(file, id)
      // 定义上传方法。

      function multipartUpload(fileList) {
        fileList[id].client
          .multipartUpload(id, file, {
            checkpoint: fileList[id] ? fileList[id].data : null,
            progress: (p, checkpoint, res) => {
              //log(p,checkpoint,res)
              if (checkpoint) {
                fileList[id].progress = p * 100;
                fileList[id].data = checkpoint;
              }
            },
            partSize: 1000 * 1024, //设置分片大小
            timeout: 120000, //设置超时时间
            mime: val.type,
          })
          .then((res) => {
            fileList[id].progress = 100;
            fileList[id].uploading = false;

            _this.$notify({
              title: "上传成功",
              message: `${fileList[id].name}上传完成`,
              type: "success",
            });
            if (index !== undefined) {
              //  alert()
              if (pathKey === "repairBeforeImage") {
                _this.form[type][index].beforeFiles.push({
                  name: file.name,
                  url: fileList[id].client.signatureUrl(res.name),
                  key: id,
                  uid: val.uid,
                });
              } else if (pathKey === "repairAfterImage") {
                _this.form[type][index].afterFiles.push({
                  name: file.name,
                  url: fileList[id].client.signatureUrl(res.name),
                  key: id,
                  uid: val.uid,
                });
              } else {
                _this.form[type][index].files.push({
                  name: file.name,
                  url: fileList[id].client.signatureUrl(res.name),
                  key: id,
                  uid: val.uid,
                });
              }
            } else if (type == "mappingUrl") {
              // var str = _this.form.wenwuBasicInformation[type];
              // str += "," + res.name;
              // _this.form.wenwuBasicInformation[type] =
              //   str.charAt(0) == "," ? str.substr(1) : str;
              _this.mappingList.push({
                name: file.name,
                url: fileList[id].client.signatureUrl(res.name),
                key: id,
                uid: val.uid,
              });

              console.log(_this.mappingList);
            } else {
              _this.form["wenwuBasicInformation"][type] = "http://zhidui-video.oss-cn-qingdao.aliyuncs.com" + res.name;
            }
            return res.name;

            // var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
            // _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

            //     _this.getList()
            // })
          })
          .catch((err) => {
            if (err.code == "RequestError" || err.code == "ConnectionTimeoutError") {
              //网络错误或超时
              setTimeout(multipartUpload, 3000);
            }
          });
      }

      multipartUpload(fileList);
    },
    getShui() {
      console.log(this.form.wenwuBasicInformation.c_name);
      var c_name = this.form.wenwuBasicInformation.c_name;
      if (!c_name) {
        this.$message.error("请输入单位名称");
        return false;
      }
      this.shuiLoading = true;
      this.$post("/trxf/main/xf/qyshcx", { c_name }).then((res) => {
        if (res.data.data.result == 1) {
          console.log(res.data.data.details[0].creditCode);

          this.form.wenwuBasicInformation.c_imployee_number = res.data.data.details[0].creditCode;
        } else {
          this.$message.warning(res.data.data.description);
        }
        this.shuiLoading = false;
      });
    },
    getMapCode(id) {
      this.$post("/devicemanage/mapcode", { mc_parent_id: id }).then((res) => {
        this.$store.commit("addMapList", { key: id, value: res.data });
      });
    },
    handlechange() {
      this.form.wenwuBasicInformation.c_port = this.services.join(",");
    },
    async getList() {
      await this.$get("/culturalRelics/wenwuBasicInformation/" + this.$route.query.id).then((res) => {
        console.log(res);
        this.form = res.data;

        this.siyouUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          this.form.wenwuBasicInformation.fileUrl,
        )}&remark=${new Date().getTime()}`;
        // this.siyouUrl = this.form.wenwuBasicInformation.fileUrl

        if (this.form.wenwuBasicInformation.buildSignInformation) {
          this.SignFileList = [
            {
              name: "图片标志",
              url: this.form.wenwuBasicInformation.buildSignInformation,
            },
          ];
        }
        if (this.form.wenwuBasicInformation.buildScopeInformation) {
          this.ScopeIFileList = [
            {
              name: "图片标志",
              url: this.form.wenwuBasicInformation.buildScopeInformation,
            },
          ];
        }
        if (this.form.wenwuBasicInformation.mappingUrl) {
          var arr = this.form.wenwuBasicInformation.mappingUrl.split(",");
          var mappingArr = [];
          arr.map((item, index) => {
            var obj = {};
            obj.name = "图纸" + index;
            obj.url = new OSS(this.$bus.config.ossConfig).signatureUrl(item);
            obj.key = item;
            mappingArr.push(obj);
          });
          this.mappingList = mappingArr;
        }
        this.areaValue[0] = String(res.data.wenwuBasicInformation.province);
        this.areaValue[1] = String(res.data.wenwuBasicInformation.city);
        this.areaValue[2] = String(res.data.wenwuBasicInformation.area);

        //  附件展示内容

        this.form["wenwuAttachmentList"].map((item) => {
          var arr = [];

          if (item.attachmentUrl) {
            let wenwuAttachmentList = item.attachmentUrl.split(",");
            wenwuAttachmentList.map((it, index) => {
              var obj = {};
              var client = new OSS(this.$bus.config.ossConfig);
              client.signatureUrl(it);
              var name = it.split("/")[it.split("/").length - 1];
              obj.name = name;
              obj.url = client.signatureUrl(it);
              arr.push(obj);
              obj.key = it;
            });
          }
          item.files = arr;

          item.fileList = {};
          item.fileRules = {
            size: 10000000,
            type: ["pdf", "doc", "docx", "html", "txt", "jpg", "png", "jpeg"],
          };
        });
        // 图片信息内容展示
        this.form["wenwuImageInformationsList"].map((item) => {
          var arr = [];

          if (item.attachmentUrl) {
            let wenwuImageInformationsList = item.attachmentUrl.split(",");
            wenwuImageInformationsList.map((it, index) => {
              var obj = {};
              var client = new OSS(this.$bus.config.ossConfig);
              client.signatureUrl(it);
              var name = it.split("/")[it.split("/").length - 1];
              console.log(name);
              obj.name = name;
              obj.url = client.signatureUrl(it);
              arr.push(obj);
              obj.key = it;
            });
          }
          item.files = arr;

          item.fileList = {};
          item.fileRules = { size: 10000000, type: ["png", "jpg", "jpeg"] };
        });

        this.form["wenwuRepairRecordsList"].map((item) => {
          var arr = [];
          var arr1 = [];
          if (item.repairBeforeImage) {
            let repairBeforeImage = item.repairBeforeImage.split(",");
            repairBeforeImage.map((it, index) => {
              var obj = {};
              var client = new OSS(this.$bus.config.ossConfig);
              client.signatureUrl(it);
              var name = it.split("/")[it.split("/").length - 1];
              console.log(name);
              obj.name = name;
              obj.url = client.signatureUrl(it);
              arr.push(obj);
              obj.key = it;
            });
          }
          if (item.repairAfterImage) {
            let repairAfterImage = item.repairAfterImage.split(",");
            repairAfterImage.map((it, index) => {
              var obj1 = {};
              var client = new OSS(this.$bus.config.ossConfig);
              client.signatureUrl(it);
              var name = it.split("/")[it.split("/").length - 1];
              console.log(name);
              obj1.name = name;
              obj1.url = client.signatureUrl(it);
              arr1.push(obj1);
              obj1.key = it;
            });
          }
          item.beforeFiles = arr;
          item.afterFiles = arr1;
          // item.files = arr1.concat(arr)
          item.fileList = {};

          console.log(this.form);
        });
      });
    },

    areaChange(val) {
      log(val);
      this.form.wenwuBasicInformation.c_province = val[0];
      this.form.wenwuBasicInformation.c_city = val[1];
      this.form.wenwuBasicInformation.c_area = val[2];
    },
    getLoa(val) {
      this.form.wenwuBasicInformation.lon = String(val[0]);
      this.form.wenwuBasicInformation.lat = String(val[1]);
    },
    proChanege(flag) {
      this.cityList = [];
      this.areaList = [];
      flag !== 1 && (this.form.wenwuBasicInformation.c_city = "");
      flag !== 1 && (this.form.wenwuBasicInformation.c_area = "");
      this.allAreaList.forEach((it) => {
        if (it.area_code == this.form.wenwuBasicInformation.c_province) {
          this.cityList = it.city;
        }
      });
    },
    // cityChanege(flag) {
    //   this.areaList = [];
    //   !flag && (this.form.wenwuBasicInformation.c_area = "");
    //   this.cityList.forEach((it) => {
    //     if (it.area_code == this.form.wenwuBasicInformation.c_city) {
    //       this.areaList = it.get_area;
    //     }
    //   });
    // },
    addList(index) {
      let obj = {};
      this.tabList[this.nowIndex].data.forEach((it) => {
        obj[it.form_name] = "";
      });
      this.form[this.tabList[this.nowIndex].dataList].push(obj);
    },
    del(index) {
      this.form[this.tabList[this.nowIndex].dataList].splice(index, 1);
    },
    changeTab(index) {
      this.nowIndex = index;
    },

    checkFiles: function() {
      if (!this.fileChecking) {
        this.fileChecking = true;

        this.form["wenwuAttachmentList"].map((item) => {
          let wenwuAttachmentList = item.attachmentUrl.split(",");
          for (var i in item.fileList) {
            wenwuAttachmentList.push(i);
          }
          item.attachmentUrl = wenwuAttachmentList.join(",").charAt(0) == "," ? wenwuAttachmentList.join(",").substr(1) : wenwuAttachmentList.join(",");
        });

        this.form["wenwuImageInformationsList"].map((item) => {
          let wenwuImageInformationsList = item.attachmentUrl.split(",");

          for (var i in item.fileList) {
            wenwuImageInformationsList.push(i);
          }
          item.attachmentUrl =
            wenwuImageInformationsList.join(",").charAt(0) == "," ? wenwuImageInformationsList.join(",").substr(1) : wenwuImageInformationsList.join(",");
        });

        this.form["wenwuRepairRecordsList"].map((item) => {
          let repairAfterImage = item.repairAfterImage.split(",");
          let repairBeforeImage = item.repairBeforeImage.split(",");
          for (var i in item.fileList) {
            console.log(item.fileList[i].pathKey);
            if (item.fileList[i].pathKey == "repairAfterImage") {
              repairAfterImage.push(i);
            } else {
              repairBeforeImage.push(i);
            }
          }
          item.repairAfterImage = repairAfterImage.join(",").charAt(0) == "," ? repairAfterImage.join(",").substr(1) : repairAfterImage.join(",");
          item.repairBeforeImage = repairBeforeImage.join(",").charAt(0) == "," ? repairBeforeImage.join(",").substr(1) : repairBeforeImage.join(",");
        });
        // attachmentUrl
        console.log(this.mappingList);
        var str = "";
        this.mappingList.map((item) => {
          str += "," + item.key;
        });
        this.form.wenwuBasicInformation["mappingUrl"] = str.substr(1);
        // for (var i in this.fileList) {
        //   // buildSignInformation.push(i)
        //   var arr =
        //     this.form["wenwuBasicInformation"][this.fileList[i].type].split(
        //       ","
        //     );
        //   arr.push(i);
        //   this.form["wenwuBasicInformation"][this.fileList[i].type] =
        //     arr.join(",").charAt(0) == ","
        //       ? arr.join(",").substr(1)
        //       : arr.join(",");
        // }
        // this.form['wenwuBasicInformation'].buildSignInformation = buildSignInformation.join(',')

        console.log(this.form);
        return;
      } else {
        // this.$message.warning("请勿重复提交");
      }
    },

    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.checkFiles();
          this.save();
        } else {
          this.nowIndex = 0;
          return false;
        }
      });
    },
    //模板下载
    downmuban() {
      var url = `${this.$config.apiUrl}/trxf/main/xf/danwei/dianwei/downloadmoban?c_company_num=${this.form.wenwuBasicInformation.c_company_num}`;
      window.open(url, "_blank");
      a;
    },
    //文件上传成功
    handlesuccess(res) {
      if (res.code == 500) {
        this.$message.error("导入失败，检查文件模板");
      } else {
        // this.$message.success("导入成功");
        this.$message({
                message: '导入成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      }
    },

    save() {
      var check = true;
      if (this.form.wenwuAttachmentList.length) {
        this.form.wenwuAttachmentList.map((item) => {
          console.log(item);

          if (!item.attachmentType && item.files.length) {
            this.$message.warning("请选择附件类型");
            check = false;
          }
        });
      }
      if (!check) {
        return;
      }

      console.log(this.areaValue);
      this.form.wenwuBasicInformation.province = this.areaValue[0];
      this.form.wenwuBasicInformation.city = this.areaValue[1];
      this.form.wenwuBasicInformation.area = this.areaValue[2];

      if (!this.$route.query.id) {
        this.$post("/culturalRelics/wenwuBasicInformation", this.form)
          .then((res) => {
            if (res.code == 500) {
              this.$message.warning(res.msg);
              return false;
            }
            if (res.code == 200) {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 700,
              });
              // this.$message.success("保存成功");
              // this.getList()
              this.fileChecking = false;

              this.$router.back();
            }
          })
          .catch((res) => {
            this.fileChecking = false;
          });
      } else {
        this.$put("/culturalRelics/wenwuBasicInformation", this.form)
          .then((res) => {
            if (res.code == 500) {
              this.$message.warning(res.msg);
              return false;
            }
            if (res.code == 200) {
              // this.$message.success("保存成功");
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 700,
              });
              this.fileChecking = false;

              this.$router.back();
            }
          })
          .catch((res) => {
            this.fileChecking = false;
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-hr {
  padding-left: 40px;

  display: flex;
  span {
    display: inline-block;
    background: rgb(37, 97, 239);
    width: 5px;
    margin-top: 3px;
    height: 15px;
    border-radius: 30%;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 168px;
  height: 168px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.rulesColor {
  display: block;
  color: #ccc;
  font-size: 12px;
}
</style>
